import Barcode from 'react-barcode';

import { Stack, Typography } from '@mui/material';

import { FormCard, ViewItem } from '@/components';
import { IKase, IProperty } from '@/models';
import { colors } from '@/theme/variables';

interface PrintLabelItemProps {
  keyId: string | number;
  kase: IKase | null;
  items: { key: string; label: string }[];
  propertyDetails?: IProperty & { relatedCFSNumber?: string };
  getItemValue: (key: string, property: IProperty | undefined) => string;
}

export const PrintLabelItem = ({
  keyId,
  kase,
  items,
  propertyDetails,
  getItemValue,
}: PrintLabelItemProps) => {
  return (
    <FormCard
      className="light-red-title"
      key={keyId}
      title={
        <Stack
          className="cardTitle"
          sx={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography variant="inherit" component="span">
            {kase?.number || ''}
          </Typography>
          <Typography variant="inherit" component="span">
            {propertyDetails?.number}
          </Typography>
        </Stack>
      }
      style={{
        fontWeight: 500,
        marginBottom: 30,
        borderBottom: `1px solid ${colors.grey[10]}`,
      }}
    >
      <Stack
        sx={{
          width: '100%',
          height: '70px',
          paddingLeft: 1,
          svg: { width: '450px', height: 'auto' },
          text: {
            display: 'none', // To hide barcode value
          },
        }}
      >
        <Barcode value={`BARCODE OF ${propertyDetails?._id}`} />
      </Stack>
      {items.map((item, index) => {
        const value = getItemValue(item.key, propertyDetails);
        if (!value && item.key === 'type') {
          return null; // Do not render 'type' if its value is missing
        }
        return (
          <ViewItem
            label={item.label}
            value={value}
            md={3}
            key={index}
            valueAsTooltip={item.key.toLowerCase() === 'description'}
            sx={{
              flexDirection: 'column',
              '.label': {
                fontSize: '0.875rem',
                fontWeight: 500,
              },
              '.value': {
                fontWeight: '400',
              },
            }}
          />
        );
      })}
    </FormCard>
  );
};
